import { get } from "./request"

const reloadSites = ({ dispatch, current_site_id }) => {
  return get(`${process.env.REACT_APP_API_URL}/internal/admin/v3/sites`)
    .then(sites => {
      dispatch({ type: "sites", sites })
      if (current_site_id) {
        const site = sites.find((site) => +site.site_id === +current_site_id)
        if (site) dispatch({ type: "select-site", site: site })
      }
      return sites
    })
}

export { reloadSites }